export const list = {
  component_name_in_template: {
    name: '字段名称',
    key: 'component_name_in_template',
    check: false
  },
  component_code: {
    name: '字段类型',
    key: 'component_code'
  },
  component_desc_in_template: {
    name: '说明',
    key: 'component_desc_in_template'
  },
  is_show: {
    name: '状态',
    key: 'is_show'
  }
};
